exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-map {\r\n    height: 400px;\r\n    width: 100%!important;\r\n}\r\n#btn-content{\r\n    margin-bottom: 5px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/controlpoint/controlpoint.component.css
// module id = ../../../../../src/app/components/controlpoint/controlpoint.component.css
// module chunks = main